/** @jsxImportSource @emotion/react */
import React from 'react';
import { css } from '@emotion/react';
import { ChatProviderType } from '../../components/chat-list-section/chat-row/typings';
import WhatsappIcon from '../../../../../shared/icons/icons-revamp/whatsapp';
import InstagramIcon from '../../../../../shared/icons/InstagramIcon.png';

type WithProviderIconProps = {
  providerType: ChatProviderType | null;
  showProviderIcon: boolean;
  children: React.ReactNode;
};

const containerCss = css({
  position: 'relative',
  display: 'inline-block',
  width: '42px',
  height: '42px',
});

const iconBadgeCss = css({
  position: 'absolute',
  bottom: 0,
  right: 0,
  transform: 'translate(30%, 30%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'white',
  borderRadius: '50%',
  height: 18,
  width: 18,
});

const instagramImgCss = css({
  width: '12px',
  height: '12px',
  objectFit: 'contain',
});

export const WithProviderIcon: React.FC<WithProviderIconProps> = ({
  providerType = ChatProviderType.WHATSAPP,
  showProviderIcon,
  children,
}) => {
  if (!showProviderIcon) {
    return <>{children}</>;
  }

  const getProviderIcon = () => {
    if (!providerType || providerType === ChatProviderType.WHATSAPP) {
      return <WhatsappIcon size={12} color="#25D366" />;
    }
    if (providerType === ChatProviderType.INSTAGRAM) {
      return <img src={InstagramIcon} alt="Instagram" css={instagramImgCss} />;
    }
  };

  return (
    <div css={containerCss}>
      {children}
      <div css={iconBadgeCss}>{getProviderIcon()}</div>
    </div>
  );
};
